export default __webpack_public_path__ + "static/digital-attendance-assesment-custom-LMS-71ad6c61721c60e8c5f03e93643c83d9.jpg";